export default __webpack_public_path__ + "static/productdiscovery-0c6316b8b9fbc8d44fbbe372a3faaeb1.gif";